import styled from 'styled-components';
import { viewports } from 'app/shared/styles/_breakpoints';
import { colors } from 'app/shared/styles/_colors';

export const ListingAdListItem = styled.li`
  text-align: center;
  vertical-align: top;
  margin-bottom: 12px;
  width: 100%;

  @media ${viewports['lg-and-up']} {
    display: inline-block;
    padding: 0px 8px;
    width: 50%;
    max-width: 404px;
    padding: 0;
    width: 100%;
    margin-bottom: 0;
  }

  @media ${viewports['xl-and-up']} {
    display: inline-block;
    max-width: 404px;
    padding: 0;
    width: 100%;
    margin-bottom: 0;
  }
`;

export const ListingAdContainer = styled.div`
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  min-height: 360px;
  width: 100%;

  @media (min-width: 436px) {
    width: 404px;
  }

  iframe {
    border-radius: 8px;
  }

  &:hover {
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.1);
  }
`;

export const AdvertisementSkeletonCard = styled.div`
  text-align: left;
  margin-bottom: 0;

  &:hover {
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.1);
  }
`;

export const AdvertisementSkeletonCardContainer = styled.div`
  background-color: ${colors['$hpx-white']};
  border-bottom: 1px solid ${colors['$hpx-grey-500']};
  color: ${colors['$hpx-blue-600']};
  position: relative;
  cursor: pointer;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  min-height: 360px;
  width: 100%;
  overflow: hidden;

  @media (min-width: 436px) {
    width: 404px;
  }
`;

export const AdvertisementSkeletonCardPhotoContainer = styled.div`
  width: 100px;
  height: 100%;
  display: inline-block;
  vertical-align: top;
  text-align: center;
  background-color: ${colors['$hpx-grey-400']};
`;

export const AdvertisementSkeletonCardContentContainer = styled.div`
  width: 150px;
  vertical-align: top;
  display: inline-block;
  padding: 8px 16px;
`;
